import { Component, OnInit } from '@angular/core';

// Angular 5 uses RxJS 5 — import "of" like this 👇
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.css']
})
export class ChartsComponent implements OnInit {

  lineChartOptions: any;
  barChartOptions: any;
  pieChartOptions: any;

  constructor() { }

  ngOnInit() {
    this.loadCharts();
  }

  loadCharts() {
    // Wrap in of() so ngx-echarts v4 does not crash
    of(true).subscribe(() => {
      this.initLineChart();
      this.initBarChart();
      this.initPieChart();
    });
  }

  initLineChart() {
    this.lineChartOptions = {
      title: { text: 'Line Chart Example' },
      tooltip: {},
      xAxis: { data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'] },
      yAxis: {},
      series: [{
        name: 'Sales',
        type: 'line',
        data: [120, 200, 150, 80, 70]
      }]
    };
  }

  initBarChart() {
    this.barChartOptions = {
      title: { text: 'Bar Chart Example' },
      tooltip: {},
      xAxis: { data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'] },
      yAxis: {},
      series: [{
        name: 'Revenue',
        type: 'bar',
        data: [300, 500, 200, 400, 600]
      }]
    };
  }

  initPieChart() {
    this.pieChartOptions = {
      title: { text: 'Pie Chart Example', left: 'center' },
      tooltip: { trigger: 'item' },
      series: [{
        name: 'Category',
        type: 'pie',
        radius: '50%',
        data: [
          { value: 335, name: 'Product A' },
          { value: 310, name: 'Product B' },
          { value: 234, name: 'Product C' },
          { value: 135, name: 'Product D' },
        ]
      }]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/charts/charts.component.ts